import { useContext } from 'react'

import { NotificationContext } from '~/src/components/shared/Notification/context'

/**
 * Hook to use the Notification context
 * @returns Notification context
 */
const useNotification = () => useContext(NotificationContext)

export default useNotification
